<template>
  <div>
    <h1 class="page-header">{{ $t('attendanceSetting.attendanceSetting') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div
            class="col-lg-9 com-md-9 col-sm-12 d-flex justify-content-start mb-2"
          >
            <p class="ts-text-gray-500">
              <b
                ><i
                  ><span class="text-danger">* </span
                  >{{ $t('attendanceSetting.note') }}</i
                ></b
              >
              {{
                $t('attendanceSetting.onlyuseratheadofficecanmodifyordelete')
              }}
            </p>
          </div>
        </div>
        <hr style="height: 1px" />
        <br />
        <form class="form-horizontal">
          <div class="row">
            <div class="col-md-5">
              <h1 class="page-header">
                {{ $t('attendanceSetting.studentPickup') }}
              </h1>
              <div class="row form-group">
                <label class="col-md-3 col-form-label required">
                  Delay (ms)
                  <i
                    class="fas fa-question-circle"
                    v-tooltip="'Set up delay after call student name'"
                  ></i>
                </label>

                <div class="col-md-4">
                  <input
                    v-model.number="model.minute_alert_after_class"
                    type="number"
                    class="form-control"
                    :class="{
                      'is-invalid': errors.has('minute_alert_after_class')
                    }"
                    :placeholder="$t('attendanceSetting.enterDelay')"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('minute_alert_after_class')"
                  >
                    {{ errors.first('minute_alert_after_class') }}
                  </div>
                </div>
              </div>

              <div class="row form-group">
                <label class="col-md-3 col-form-label">
                  {{ $t('attendanceSetting.suffixAudio') }}
                  <i
                    class="fas fa-question-circle"
                    v-tooltip="
                      'This audio are going to play after student name'
                    "
                  ></i>
                </label>
                <div class="col-md-3">
                  <div class="row">
                    <div class="col-md-7 col-sm-8">
                      <audio
                        controls
                        controlsList="nodownload"
                        ref="audioPlayer"
                      >
                        <source :src="src" type="audio/mpeg" />
                      </audio>
                    </div>
                    <div class="col-md-1 col-sm-2">
                      <input
                        type="file"
                        id="audio"
                        ref="audio"
                        style="display: none"
                        @change="selectedFile"
                      />
                      <label
                        class="col-form-label pointer"
                        title="Add file"
                        for="audio"
                      >
                        <i class="fas fa-paperclip fa-2x"></i>
                      </label>
                    </div>
                    <div class="col-md-1 col-sm-2">
                      <label
                        class="col-form-label pointer"
                        title="remove sound file"
                        @click.prevent="destroy"
                      >
                        <ts-button
                          :disabled="!resource.attendance_suffix_audio_file"
                          class="btn-xs"
                        >
                          <i
                            v-if="deleting"
                            class="fas fa-spinner fa-pulse text-danger"
                          ></i>
                          <i class="fas fa-trash fa-2x text-danger" v-else></i>
                        </ts-button>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 mb-3">
              <h1 class="page-header">
                {{ $t('attendanceSetting.allAboutMyDay') }}
              </h1>
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label col-label">{{
                    $t('attendanceSetting.isAllAboutMyDayAuto')
                  }}</label>
                </div>
                <div class="col-md-6">
                  <a-switch
                    v-model="model.is_all_about_my_day_auto"
                    @change="
                      () => (
                        (model.is_immediately_sent = false),
                        (model.time_tobe_send = null)
                      )
                    "
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label col-label">{{
                    $t('attendanceSetting.isImmediatelySent')
                  }}</label>
                </div>
                <div class="col-md-6">
                  <a-switch
                    v-model="model.is_immediately_sent"
                    @change="() => (model.time_tobe_send = null)"
                    :disabled="!model.is_all_about_my_day_auto"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 mb-3 mb-3">
                  <label
                    class="form-label col-label"
                    :class="{
                      required:
                        !model.is_immediately_sent &&
                        model.is_all_about_my_day_auto
                    }"
                    >{{ $t('attendanceSetting.timeToBeSent') }}</label
                  >
                </div>
                <div class="col-md-6">
                  <ts-time-picker-input
                    :use24Hour="true"
                    :class="{
                      'is-invalid': errors.has('time_tobe_send')
                    }"
                    v-model="model.time_tobe_send"
                    :disabled="
                      !model.is_all_about_my_day_auto ||
                      model.is_immediately_sent
                    "
                  />
                  <div class="validate" v-if="errors.has('time_tobe_send')">
                    {{ errors.first('time_tobe_send') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <h1 class="page-header">
                {{ $t('attendanceSetting.attendance') }}
              </h1>
              <div class="row">
                <label class="col-label col-md-6" style="margin-top: 4px">{{
                  $t('attendanceSetting.periodInMinute')
                }}</label>
                <div class="col-md-6">
                  <input
                    class="form-control"
                    placeholder="Enter Period In Minute"
                    v-model="model.att_notify_period_in_minute"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="row">
              <h1 class="page-header">
                {{ $t('attendanceSetting.reportCard') }}
              </h1>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label class="form-label col-label">{{
                  $t('attendanceSetting.isDisplayOnapp')
                }}</label>
              </div>
              <div class="col-md-6">
                <a-switch v-model="model.is_display_on_app" />
              </div>
            </div>
          </div>
          <div class="col-md-12 text-right">
            <ts-button class="btn-primary" :waiting="waiting" @click="store">{{
              $t('save')
            }}</ts-button>
          </div>
        </form>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'attendance-setting',
  data () {
    return {
      waiting: false,
      deleting: false,
      src: '',
      errors: new Errors(),
      model: {
        company_id: '',
        minute_alert_after_class: '',
        audio: '',
        is_all_about_my_day_auto: false,
        is_immediately_sent: false,
        time_tobe_send: null,
        att_notify_period_in_minute: '',
        is_display_on_app: false
      }
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    ...mapState('attendanceSetting', ['resource'])
  },
  methods: {
    fetchData () {
      this.$store
        .dispatch('attendanceSetting/fetch')
        .then(respone => {
          this.model = {
            company_id: respone.company_id,
            minute_alert_after_class: respone.minute_alert_after_class,
            audio: respone.attendance_suffix_audio_file,
            is_all_about_my_day_auto: respone.is_all_about_my_day_auto,
            is_immediately_sent: respone.is_immediately_sent,
            time_tobe_send: respone.time_tobe_send,
            att_notify_period_in_minute: respone.att_notify_period_in_minute,
            is_display_on_app: respone.is_display_on_app
          }
          this.src = respone.attendance_suffix_audio_file
          this.$refs.audioPlayer.load()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    selectedFile (event) {
      const file = event.target.files[0]
      let reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = e => {
        this.src = e.target.result
        this.$refs.audioPlayer.load()
        this.model.audio = file
      }

      if (file) {
        if (/\.(mp3|mpeg)$/i.test(file.name)) {
        } else {
          this.src = ''
          this.$toasted.error('invalid file type!')
          this.$refs.audio.value = ''
        }
      }
    },
    store () {
      this.errors = new Errors()
      this.waiting = true
      let formData = new FormData()
      formData.append(
        'minute_alert_after_class',
        this.model.minute_alert_after_class
      )
      formData.append('audio', this.model.audio)

      formData.append(
        'is_all_about_my_day_auto',
        this.model.is_all_about_my_day_auto
      )
      formData.append('is_immediately_sent', this.model.is_immediately_sent)
      formData.append('time_tobe_send', this.model.time_tobe_send)
      formData.append(
        'att_notify_period_in_minute',
        this.model.att_notify_period_in_minute
      )
      formData.append('is_display_on_app', this.model.is_display_on_app)

      this.$store
        .dispatch('attendanceSetting/store', formData)
        .then(respone => {
          this.waiting = false
          this.fetchData()
          this.$toasted.success(respone.message)
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.waiting = false
          this.$toasted.error(error.message)
        })
    },
    async destroy () {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        this.deleting = true
        this.$store
          .dispatch('attendanceSetting/destroy', this.model.company_id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
            this.deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            this.deleting = false
          })
      }
    }
  }
}
</script>

<style lang="css" scoped>
audio {
  filter: sepia(20%) saturate(70%) grayscale(1) contrast(99%) invert(12%);
  width: 100%;
  height: 35px;
  outline: none;
}
.pointer {
  cursor: pointer;
}
</style>
